import React, { createContext } from 'react';
import PropTypes from 'prop-types';
const SelectContext = createContext({});
const { Provider } = SelectContext;
function SelectStore({ value, children }) {
	return <Provider value={value}>{children}</Provider>;
}
SelectStore.propTypes = {
	value: PropTypes.object,
	children: PropTypes.node,
};
export { SelectContext };
export default SelectStore;
